//noScroll
class FrontPage {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){

    var windowWidth = $(window).width();
    var windowSm = 768;
    if (windowWidth <= windowSm) {
      // SPサイズ 

      const futureSwiper = new Swiper('.future-swiper', {
        slidesPerView: 1.2,
        spaceBetween: 14,
        centeredSlides: true,
        loop: true,
        loopAdditionalSlides: 1,
        speed: 300, 
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
          renderBullet: function (index, className) {
            // ページネーションに番号を表示
            return '<div class="' + className + '">' + ('0' + (index + 1)) + "</div>";
          },
        },
      });
      
      const cards = document.querySelectorAll(".js-card__front");
      const overlay = document.querySelector(".overlay");
      const futureSwipers = document.querySelector(".s-future__spSwiper");
      const closeButton = document.querySelector(".s-future__spSwiper-close");
      const swipersSlides = document.querySelectorAll(".s-future__spSwiper-slide");
      
      cards.forEach((card) => {
        card.addEventListener('click', () => {
          overlay.classList.add("is-active");
          const dataIndex = card.dataset.slideIndex;
          futureSwipers.classList.add("is-active");
      
          swipersSlides.forEach((slide, index) => {
            const dataModal = slide.dataset.modal;
            if (dataModal === dataIndex) {
              futureSwiper.slideTo(index);
              futureSwiper.update();
              overlay.classList.add("is-active");
            } else {
              slide.classList.remove("swiper-slide-active");
            }
          });
      
        });
      });
      
      // 閉じるボタンの挙動
      closeButton.addEventListener('click', function () {
        overlay.classList.remove("is-active");
        futureSwipers.classList.remove("is-active");
      });

      overlay.addEventListener('click', function () {
        overlay.classList.remove("is-active");
        futureSwipers.classList.remove("is-active");
      });

    } else {
      // PCサイズ

      // カード 回転
      // ======================================================
      const cards = document.querySelectorAll('.js-card');
        function transition() {
          if (this.classList.contains('is-active')) {
            this.classList.remove('is-active')
          } else {
            this.classList.add('is-active');
          }
        }
        cards.forEach(card => card.addEventListener('click', transition));
      }
    
      var voiceSwiper = new Swiper('.voiceSwiper', {
        slidesPerView: 1.2,
        spaceBetween: 8,
        centeredSlides: true,
        loop: true,
        loopAdditionalSlides: 1,
        speed: 1000,
        autoplay: {
          delay: 4000,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          //767px以上の場合
          767: {
            slidesPerView: 2.5,
            spaceBetween: 16,
          }
        }
      });

    // var mySwiper = new Swiper('.swiper-container', {
    //   loop: true,
    //   slidesPerView: 'auto',
    //   speed: 30000,
    //   allowTouchMove: false,
    //   autoplay: {
    //     delay: 0,
    //     reverseDirection: true,
    //   },
    // });

    // 300pxスクロールしたらheader-hideを付与し、top-headerを削除
    window.addEventListener('scroll', () => {
      const header = document.querySelector('.l-header');
      const topHeader = document.querySelector('.top-header');
      if (window.scrollY > 300) {
        header.classList.add('header-hide');
        header.classList.remove('top-header');
      } else {
        header.classList.remove('header-hide');
        if (!topHeader) {
          header.classList.add('top-header');
        }
      }
    });

    window.addEventListener('scroll', () => {
      const header = document.querySelector('.l-header');
      const sMvSection = document.querySelector('.s-mv');
  
      if (sMvSection) {
          const sMvSectionBottom = sMvSection.offsetTop + sMvSection.offsetHeight;
          if (window.scrollY > sMvSectionBottom) {
              header.classList.add('header-display');
  
              // header-displayクラスがある場合
              const megaMenu = document.querySelector(".js-megaMenu");
              const megaMenuClick = document.querySelectorAll(".js-megaMenu-click");
              megaMenu.classList.remove('is-topPage');
              megaMenuClick.forEach(element => {
                  element.classList.remove('is-topPage');
              });
          } else {
              header.classList.remove('header-display');
  
              // header-displayクラスがない場合
              const megaMenu = document.querySelector(".js-megaMenu");
              const megaMenuClick = document.querySelectorAll(".js-megaMenu-click");
              megaMenu.classList.add('is-topPage');
              megaMenuClick.forEach(element => {
                  element.classList.add('is-topPage');
              });
          }
      }
  });
  


    // if (document.querySelector('.header-display')) {
    //     // header-displayクラスがある場合
    //     megaMenu.classList.remove('is-topPage');
    //     megaMenuClick.forEach(el => {
    //         el.classList.remove('is-topPage');
    //     });
    // } else {
    //     // header-displayクラスがない場合
    //     megaMenu.classList.add('is-topPage');
    //     megaMenuClick.forEach(el => {
    //         el.classList.add('is-topPage');
    //     });
    // }
  }
}
